import React from "react";

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div>
        <img
          src={"/Loader.svg"}
          alt="Loading..."
          style={{ height: "60px", width: "60px" }}
        />
      </div>
    </div>
  );
};

export default Loader;
